import { Box, TableCell, TableRow } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";

import InlineNameField, { type InlineNameEdit } from "./InlineNameField";
import { FROZEN_COLUMN_COUNT, FROZEN_RIGHT, ROW_BG, frozenCellSx } from "./frozenColumns";

interface NewFolderRowProps extends InlineNameEdit {
  /** Pre-filled and selected, so typing replaces it. A blank name keeps it. */
  initialName: string;
  /** Total columns in the table; the name spans all but the frozen ones. */
  colSpan: number;
}

/**
 * A folder that doesn't exist yet: the top row of the folder list, its name
 * selected and editable, like a new folder in a file manager. Enter or
 * clicking away creates it; Escape drops it.
 */
export default function NewFolderRow({ initialName, colSpan, ...edit }: NewFolderRowProps) {
  return (
    <TableRow
      sx={{
        borderLeft: "3px solid #f59e0b",
        backgroundColor: ROW_BG.highlightFolder,
      }}
    >
      <TableCell colSpan={Math.max(1, colSpan - FROZEN_COLUMN_COUNT)} sx={{ py: 0.75 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <FolderIcon sx={{ color: "#f59e0b" }} />
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <InlineNameField initialName={initialName} ariaLabel="Folder name" messages="caption" {...edit} />
          </Box>
        </Box>
      </TableCell>
      {/* Empty frozen cells keep the row's colour under the sticky columns. */}
      <TableCell padding="none" sx={frozenCellSx(FROZEN_RIGHT.pin)} />
      <TableCell padding="none" sx={frozenCellSx(FROZEN_RIGHT.eye)} />
      <TableCell padding="none" sx={frozenCellSx(FROZEN_RIGHT.locate)} />
      <TableCell padding="none" sx={frozenCellSx(FROZEN_RIGHT.menu, true)} />
    </TableRow>
  );
}
